module.exports = __webpack_public_path__ + "img/img11.bfd1bd58.png";